const colorList = ['#73DDFF', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF', '#58D5FF', '#944f21', '#2a7953']

/**
 * default label options
 *
 * @param {number} rotate
 */
const _defaultLabelOption = function(rotate = 90) {
  return {
    normal: {
      show: true,
      formatter: '{c}',
      fontSize: 10,
      rotate: rotate,
      rich: {
        name: {
          textBorderColor: '#fff'
        }
      }
    }
  }
}

/**
 * default pie options
 */
const _defaultPieOptions = {
  title: { text: '', subtext: '', x: 'center', y: 'center', textStyle: { fontWeight: 'normal', fontSize: 14 }},
  tooltip: { trigger: 'item' },
  legend: {
    // orient: 'vartical',
    // x: 'left',
    // left: '60%',
    orient: 'horizontal',
    bottom: '0',
    // itemWidth: 8,
    // itemHeight: 8,
    // itemGap: 16,
    /* formatter:function(name){
      var oa = option.series[0].data;
      var num = oa[0].value + oa[1].value + oa[2].value + oa[3].value+oa[4].value + oa[5].value + oa[6].value + oa[7].value+oa[8].value + oa[9].value ;
      for(var i = 0; i < option.series[0].data.length; i++){
          if(name==oa[i].name){
              return ' '+name + '    |    ' + oa[i].value + '    |    ' + (oa[i].value/num * 100).toFixed(2) + '%';
          }
      }
    }*/

    formatter: function(name) {
      return '' + name
    }
  },
  //   color: ['rgb(61,171,232)', 'rgb(95,193,215)', 'rgb(146,198,96)', 'rgb(59,175,134)', 'rgb(53,128,198)'],
  series: [{
    type: 'pie',
    center: ['50%', '50%'],
    radius: ['50%', '70%'],
    silent: false, // 图形是否不响应和触发鼠标事件
    minAngle: 5, // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
    clockwise: true, // 是否开启点击
    avoidLabelOverlap: true, // 是否启用防止标签重叠策略
    hoverOffset: 10,
    // itemStyle: {
    //   normal: {
    //     color: function(params) {
    //       return colorList[params.dataIndex]
    //     }
    //   }
    // },
    emphasis: {
      label: {
        show: true,
        fontSize: '12',
        // position: 'center',
        fontWeight: 'bold'
      }
    },
    label: {
      show: false,
      position: 'center',
      formatter: '{b}\n\n营收额：{c} 元'
    },
    labelLine: {
      normal: {
        length: 10,
        length2: 30,
        lineStyle: {
          width: 1
        }
      }
    },
    data: []
  }]
}

/**
   * default line chart options
   */
const _defaultLineOptions = {
  title: {
    text: 'Timeline Builds',
    padding: 20,
    x: 'left',
    textStyle: {
      fontSize: 15
    }
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      crossStyle: {
        color: '#999'
      },
      label: {
        formatter: function(params) {
          return isNaN(params.value) ? params.value : Math.ceil(params.value)
        }
      }
    },
    textStyle: {
      fontSize: 10
    }
  },
  toolbox: {
    top: 10,
    right: 0,
    // orient: 'vertical',
    show: true,
    feature: {
      mark: { show: true, title: 'Switch' },
      magicType: { show: true, type: ['line', 'bar'], title: { line: '', bar: '' }},
      restore: { show: true, title: ' ' },
      saveAsImage: { show: true, title: ' ' }
    }
  },
  dataZoom: [
    {
      show: true
    },
    {
      type: 'inside',
      textStyle: {
        fontSize: 9
      }
    }
  ],
  legend: {
    data: ['Passed', 'Failed', 'Total'],
    left: 'center',
    padding: 20
  },
  xAxis: {
    type: 'category',
    data: [],
    axisPointer: {
      type: 'shadow'
    },
    axisLabel: {
      fontSize: 10
    }
  },
  yAxis: {
    type: 'value',
    interval: 20
  },
  grid: {
    left: '4%',
    right: '4%',
    containLabel: true
  },
  series: [
    {
      name: 'Total',
      type: 'line',
      yAxisIndex: 0,
      data: [],
      label: _defaultLabelOption(0),
      color: function(params) {
        return '#29517b'
      },
      lineStyle: { color: '#29517b' }
    },
    {
      name: 'Passed',
      type: 'bar',
      data: [],
      label: _defaultLabelOption(),
      color: function(params) {
        return '#38aa73'
      },
      lineStyle: { color: '#38aa73' }
    },
    {
      name: 'Failed',
      type: 'bar',
      data: [],
      label: _defaultLabelOption(),
      color: function(params) {
        return '#d15b47'
      },
      lineStyle: { color: '#d15b47' }
    }
  ]
}

/**
 * build chart options
 *
 * @param {string} type
 */
export const buildChartOptions = (type, data) => {
  if (type === 'pie') {
    const options = _defaultPieOptions
    // options.title.text = title
    options.series[0].data = data
    return options
  } else if (type === 'line') {
    return _defaultLineOptions
  }
}
